import React, { useRef } from 'react';
import { Link } from 'react-router-dom'

import SearchBox from '../components/psc/lib/SearchBox'
import SelectFilterAttributeMulti from '../components/psc/lib/SelectFilterAttributeMulti'
import GncDataTable from '../components/psc/lib/GncDataTable'

import useUserManagement from '../hooks/useUserManagement'
import useTableSlots from '../hooks/useTableSlots'

// allUsers from useUserManagement doesn't update after we create a User
// :(
// Because of useLocalStorage? OR something else?
//
// For now, just do a normal load of /v0/users ...

const Users = () => {
    const table = useRef(null)
    const localStorageOrderKey = 'tblUsersOrder'
    const defaultOrder = [[ 0, 'asc' ]]
    
    const {
        allUsers, 
        userHasRole,
        activeUsers
    } = useUserManagement()

    const {
        linkSlot,
    } = useTableSlots()

    const columns = [
        { data: 'forename' },
        { data: 'surname' },
        { data: 'usergroups' },
        { data: 'position' },
        { data: 'normal_user', visible: false }
    ]

    const tableSlots = {
        0: (data, type, row) => linkSlot(data, type, row, `/users/${row.id}`),
        1: (data, type, row) => linkSlot(data, type, row, `/users/${row.id}`),
        2: (data, type, obj) => {
            if (type !== 'display') {
                return obj.usergroups?.map(group => group.name).join(', ') || ''
            }
            if (!obj.usergroups) return ''
            return (
                <>
                {
                    obj.usergroups
                       .sort((a, b) => a.name > b.name)
                       .map(group => (
                           <span key={group.name} className="comma-list no-wrap">{group.name}</span>
                       ))
                }
                </>
            )
        },
        3: (data, type, obj) => {
            if (!obj.roles) return ''
            return obj.roles
                      .sort((a, b) => a.list_order > b.list_order)
                      .map(r => r.full_name)
                      .join(', ')
        },
        4: (data, type, obj) => {
            return userHasRole(obj, 'normal_user') ? 'Active' : 'Disabled'
        }
    }

    const tableHead = (
        <tr>
            <th>Forename</th>
            <th>Surname</th>
            <th>User Groups</th>
            <th>Roles (Individual)</th>
            <th>Status</th>
        </tr>
    )

    const userStatuses = {
        single_select_values: [
            {
                value: 'Active'
            },
            {
                value: 'Disabled'
            }
        ]
    }

    return (
            <div className="wrapper wrapper-content">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="ibox float-e-margins">

                            <div className="ibox-title">
                                <h2>Users</h2>

                                <div className="pre-table-buttons">
                                    <Link to="/users/new" className="btn btn-mr btn-primary" type="button">New User</Link>
                                    <Link to="/security">Manage Security</Link>
                                </div>

                                <div key="newText1" style={{color: 'rgba(103, 106, 108, 0.65)'}}>
                                    You have <strong>{activeUsers.length}</strong> Active Users.
                                 </div>
                            </div>

                            <div className="ibox-content">
                                <div className="row">
                                    <SearchBox tableRef={table} />
                                    <SelectFilterAttributeMulti
                                        tableRef={table}
                                        attribute={userStatuses}
                                        columnIndex="4"
                                        localStorageKey="user-list-statuses"
                                        placeholder="Select Account Status..."
                                    />

                                </div>

                                <GncDataTable
                                    tableRef={table}
                                    dataUrl="/v0/users"
                                    defaultOrder={defaultOrder}
                                    localStorageOrderKey={localStorageOrderKey}
                                    columns={columns}
                                    tableSlots={tableSlots}
                                    tableHead={tableHead}
                                    tableFoot={tableHead}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    )
}

export default Users
